import {
  Box,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router";
import { schoolNamesDict } from "../../../../enum";
import { stylesCommon, stylesProduct } from "../../css";
import dict from "../../dictionary";
import { useGetProducts } from "../../fetch/product";
import useUserStateContext from "../../userstate";
import { addTax, formatPrice, renderTerm } from "../../util";
import ProductDetailCourses from "./ProductDetailCourses";
import {
  extractApplicationDueDate,
  extractCourses,
  renderCoursePeriod,
  renderPriceRange,
} from "./ProductDetailIkusei";
import {
  remainingsNumToMessage,
  renderApplyButton,
} from "./ProductDetailOther";
import ProductDetailTop from "./ProductDetailTop";

const ProductDetailDataEng = (props: any) => {
  const { classes } = props;
  const { userState, setRedirect } = useUserStateContext();
  const {
    productsDataEng: products,
    getProducts,
    typesDataEng,
    weekdaysDataEng,
    setProductsDataEng: setProducts,
  } = useGetProducts();
  const [
    selectedType,
    setSelectedType
  ] = useState<string | undefined>(undefined);
  const [
    selectedWeekday,
    setSelectedWeekday
  ] = useState<string | undefined>(undefined);
  const [
    selectedProduct,
    setSelectedProduct
  ] = useState<any | undefined>(undefined);
  const [filteredWeekdays, setFilteredWeekdays] = useState([]);
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [schoolName, setSchoolName] = useState<string>("");
  const [productDescription, setProductDescription] = useState<any>("");

  const [coursesForRender, setCoursesForRender] = useState<any[]>([]);
  const [coursesRendered, setCoursesRendered] = useState(false);

  useEffect(() => {
    if (userState.signedIn === false) {
      setRedirect(window.location.pathname);
      props.history.push("/login");
    }
    getProducts({});
  }, [userState, props.history]);

  useEffect(() => {
    const term = `term_${props.match.params.term}`;
    const school = props.match.params.school
      ? `school_${props.match.params.school}`
      : `school_tokyo`;
    const schoolNameTmp = schoolNamesDict.filter(
      (schoolNameDict: { name: string; nameJa: string }) => {
        return schoolNameDict.name === school.replace(`school_`, ``);
      }
    );
    setSchoolName(schoolNameTmp.length > 0 ? schoolNameTmp[0].nameJa : ``);
    const productsFiltered = products.filter((product: any) => {
      return product.tags.includes(term) && product.tags.includes(school);
    });
    products.length !== productsFiltered.length &&
      setProducts(productsFiltered);
    products.length > 0 && setProductDescription(products[0].description);
  }, [products]);

  useEffect(() => {
    if (coursesRendered === false && products.length > 0) {
      setCoursesForRender(extractCourses(products));
      setCoursesRendered(true);
    }
  }, [products]);

  // when multiple terms run parallelly, weekdays and types need to be
  // filtered for particular term shown in the page.
  useEffect(() => {
    if (products.length > 0) {
      const typesFiltered = typesDataEng.filter((type: any) => {
        let typeExists = false;
        products.forEach((product: any) => {
          typeExists = product.tags.includes(type.value) ? true : typeExists;
        });
        return typeExists;
      });
      setFilteredTypes(typesFiltered);
    }
  }, [typesDataEng]);

  useEffect(() => {
    if (products.length > 0) {
      const weekdaysFiltered = weekdaysDataEng.filter((weekday: any) => {
        let weekdayExists = false;
        products.forEach((product: any) => {
          weekdayExists = product.tags.includes(weekday.value)
            ? true
            : weekdayExists;
        });
        return weekdayExists;
      });
      setFilteredWeekdays(weekdaysFiltered);
    }
  }, [weekdaysDataEng]);

  useEffect(() => {
    if (selectedType && selectedWeekday) {
      selectProduct(selectedType, selectedWeekday);
    }
  }, [selectedType, selectedWeekday]);

  const selectProduct = (type: string, weekday: string) => {
    const selectedProductArray = products.filter((product: any) => {
      return product.tags.includes(type) && product.tags.includes(weekday);
    });
    selectedProductArray.length > 0
      ? setSelectedProduct(selectedProductArray[0])
      : setSelectedProduct(undefined);
  };

  return (
    <Fragment>
      <ProductDetailTop
        productTitle={`【${renderTerm(props.match.params.term)}】${
          dict.product.dataEngTitle
        }`}
        productDescription={productDescription}
        coursePeriod={products.length > 0 && renderCoursePeriod(products)}
        priceRange={products.length > 0 && renderPriceRange(products)}
        dueDate={products.length > 0 && extractApplicationDueDate(products)}
        schoolName={schoolName}
        backImage={classes.backImageIkusei}
      />

      <ProductDetailCourses
        courses={coursesForRender}
        stepHeader={"Step"}
        scheduleLink={
          `https://datamix-internal.s3-ap-northeast-1.amazonaws.com/info-session/datamix_schedule_de_${props.match.params.term}_${props.match.params.school}.pdf`
        }
      />

      <Container maxWidth="xl" className={classes.selectionContainer}>
        <Container maxWidth="lg" className={classes.pt2}>
          <Box className={classes.mb2}>
            <Typography variant="subtitle2">
              {dict.product.applicationInstruction}
            </Typography>
          </Box>
          <Grid container className={classes.mb4}>
            <Grid item xs={12} md={2}>
              <Typography className={classes.mt1}>
                {dict.product.type}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl component="fieldset">
                <RadioGroup
                  value={selectedType}
                  onChange={(event: any) => {
                    setSelectedType(event.target.value);
                  }}
                >
                  {filteredTypes &&
                    filteredTypes.map((type: any) => {
                      return (
                        <FormControlLabel
                          value={type.value}
                          control={<Radio color="primary" />}
                          label={type.label}
                        />
                      );
                    })}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2} className={classes.mb1}>
              <Typography className={classes.mt1}>
                {dict.product.weekday}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl component="fieldset">
                {/* <FormLabel component="legend">{dict.product.weekday}</FormLabel> */}
                <RadioGroup
                  value={selectedWeekday}
                  onChange={(event: any) => {
                    setSelectedWeekday(event.target.value);
                  }}
                >
                  {filteredWeekdays &&
                    filteredWeekdays.map((weekday: any) => {
                      return (
                        <Fragment>
                          <FormControlLabel
                            value={weekday.value}
                            control={<Radio color="primary" />}
                            label={weekday.label}
                          />
                          {products.map((product: any) => {
                            if (product.tags.includes(selectedType) === true) {
                              if (
                                product.tags.includes(weekday.value) === true
                              ) {
                                return (
                                  <Typography className={classes.ml4}>
                                    {remainingsNumToMessage(product.remainings)}
                                  </Typography>
                                );
                              }
                            }
                          })}
                        </Fragment>
                      );
                    })}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Divider />
          {selectedProduct && (
            <Fragment>
              <Grid container className={classes.mt3}>
                <Grid item xs={12} md={2}>
                  <Typography>{dict.product.selectedProduct}</Typography>
                </Grid>
                <Grid item xs={12} md={10}>
                  <Typography>{selectedProduct.name}</Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.mt3}>
                <Grid item xs={12} md={2}>
                  <Typography>{dict.common.totalPrice}</Typography>
                </Grid>
                <Grid item xs={12} md={10}>
                  <Typography>
                    {formatPrice(addTax(selectedProduct.price))}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.mt3}>
                <Grid item xs={12} md={3}></Grid>
                <Grid item xs={12} md={6}>
                  <Box className={classes.mb4}>
                    {renderApplyButton(selectedProduct, props, classes)}
                    {selectedProduct.remainings == 0 &&
                      !selectedProduct.totally_confirmed && (
                        <Box className={classes.mt1}>
                          <Typography variant="caption">
                            {dict.order.subscribeMessage}
                          </Typography>
                        </Box>
                      )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={3}></Grid>
              </Grid>
            </Fragment>
          )}
        </Container>
      </Container>
    </Fragment>
  );
};

export default withStyles(stylesCommon)(
  withStyles(stylesProduct)(withRouter(ProductDetailDataEng))
);
